import gql from "graphql-tag";

export const getMe = gql`
  query {
    me {
      id
      email
      name
      profilePictureUrl
    }
  }
`;

export const getMeOptions = {
  name: "me",
};
